import React from "react";

/**
 * Calls a callback function on the initial mount of a component.
 */
export default (callback: () => void, delayMs?: number) => {
  const isInitialMount = React.useRef(true);
  React.useEffect(() => {
    if (isInitialMount.current) {
      if (delayMs !== undefined) {
        setTimeout(callback, delayMs);
      } else {
        callback();
      }
    }
    isInitialMount.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
